import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default, { useContext } from 'react';
import PropTypes__default from 'prop-types';
import { AutocompleteContext, AutocompleteInputContext } from '../autocomplete-context.js';
import Input from '../../input/input.js';

var AutocompleteInput = function (props) {
  var _a = useContext(AutocompleteContext),
    containerId = _a.containerId,
    focusedOption = _a.focusedOption,
    isMultiselect = _a.isMultiselect;
  var _b = useContext(AutocompleteInputContext),
    optionsListVisible = _b.optionsListVisible,
    onChange = _b.onChange,
    value = _b.value;
  var handleOnChange = function (event) {
    onChange(event);
    if (props.onChange) {
      props.onChange(event);
    }
  };
  return /*#__PURE__*/React__default__default.createElement(Input, __assign({}, props, {
    role: "combobox",
    "aria-controls": "".concat(containerId, "-listbox"),
    "aria-expanded": optionsListVisible,
    "aria-describedby": isMultiselect ? "autocomplete-selected-list-for-".concat(containerId) : ''
  }, optionsListVisible && focusedOption >= 0 && {
    'aria-activedescendant': "".concat(containerId, "-option-").concat(focusedOption)
  }, {
    value: value,
    onChange: handleOnChange
  }));
};
AutocompleteInput.displayName = 'AutocompleteInput';
AutocompleteInput.propTypes = {
  extraClasses: PropTypes__default.string
};

export { AutocompleteInput as default };
